import type { IBadgeProps } from "./types"
import { BADGE_STYLES } from "./types"

export const Badge = ({ icon, text, variant = "default" }: IBadgeProps) => {
	const style = BADGE_STYLES[variant]
	return (
		<span
			className={`inline-flex items-center gap-1 rounded-full ${style.bg} px-2.5 py-0.5 font-medium ${style.text} text-xs`}
		>
			{icon}
			{text}
		</span>
	)
} 